var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#646567"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M13.75 9.582v.833h-7.5v-.833h7.5Z"
  })));
};
export { SvgCollapse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iOS41IiBzdHJva2U9IiM2NDY1NjciLz4KPHBhdGggZD0iTTEzLjc1IDkuNTgyMDNMMTMuNzUgMTAuNDE0Nkw2LjI1IDEwLjQxNDZMNi4yNSA5LjU4MjAzTDEzLjc1IDkuNTgyMDNaIiBmaWxsPSIjMTgxODE4Ii8+Cjwvc3ZnPgo=";